module.exports = __webpack_public_path__ + "images/emoji/flower_playing_cards.a3e237779e6ef137f6a6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/flower_playing_cards.png
// module id = e3Qw
// module chunks = 14